import React, { useEffect, useState } from 'react';
import FormGroup from '../../../components/controls/Form/components/FormGroup';
import InputField from '../../../components/controls/Form/components/InputField';
import DropdownField from '../../../components/controls/Form/components/DropdownField';
import { apiGET } from '../../../utils/networking';
import PhoneNumberField from '../../../components/controls/Form/components/PhoneNumberField';
import Heading from '../../../components/controls/Typography/Heading';
import { PHONE_INITIAL_COUNTRY_CODE, PHONE_NUMBER_VALIDATION_MIN_LENGTH } from '../../../utils/Constants';
import useRecommendation from '../../../utils/useRecommendation';

/**
 * @typedef TLookupStates
 * @type {{
 *  id: number,
 *  isoCode2: null|string,
 *  isoCode3: null|string,
 *  sortIdx: null|number,
 *  valueAbbr: null|string,
 *  valueId: string,
 *  valueString: string,
 * }[]}
 */

export const PhysicalTherapistInfo = () => {
  const recommendation = useRecommendation();
  const observationHoursDataEval = recommendation.item?.observationHoursDataEval;
  const [stateValues, setStateValues] = useState(/** @type TLookupStates */([]));

  const getStateValues = () => {
    //country id 222 is only for getting states of united states
    apiGET('/recommendation/rest/lookup/states?countryId=222')
      .then((response) => {
        const result = /** @type TLookupStates */(response.body);
        setStateValues(result)
      });
  }

  const handleChange = (/** @type {string} */ propertyName, /** @type {any} */ value) => {
    recommendation.actions.observationHours.handleChange(propertyName, value);
  }

  const handleStatesChange = (propertyName, value) => {
    recommendation.actions.observationHours.handleChange(propertyName, value ? parseInt(value) ?? null : null);
  }

  useEffect(() => {
    getStateValues();
  }, []);

  return observationHoursDataEval ? (
    <div className='lsn-observation-group lsn-observation-therapist-info'>
      <Heading bold level={3} tabIndex={0} asSpan className="lsn-obs-recommendation-form-header">
        Physical Therapist Information
      </Heading>

      <FormGroup
        label='First Name'
        required
        horizontal
        controlRender={(params) =>
          <InputField
            title={'First Name'}
            name={'supervisorFirstName'}
            onChange={handleChange}
            value={observationHoursDataEval.supervisorFirstName ?? ''}
            placeholder={'George'}
            customErrorPrefix={'First Name'}
            {...params}
          />}
      />

      <FormGroup
        label='Last Name'
        required
        horizontal
        controlRender={(params) => <InputField
          title={'Last Name'}
          name={'supervisorLastName'}
          value={observationHoursDataEval.supervisorLastName ?? ''}
          onChange={handleChange}
          placeholder={'Fenny'}
          customErrorPrefix={'Last Name'}
          {...params}
        />}
      />

      <FormGroup
        label='Phone'
        required
        horizontal
        controlRender={(params) => <PhoneNumberField
          title={'Phone'}
          name={'supervisorPhone'}
          onChange={handleChange}
          initialCountryCode={PHONE_INITIAL_COUNTRY_CODE}
          minLen={PHONE_NUMBER_VALIDATION_MIN_LENGTH}
          value={observationHoursDataEval.supervisorPhone ?? ''}
          {...params}
        />}
      />

      <FormGroup
        label='Email'
        required
        horizontal
        controlRender={(params) => <InputField
          inputType='email'
          title={'Email'}
          name={'supervisorEmail'}
          onChange={handleChange}
          value={observationHoursDataEval.supervisorEmail ?? ''}
          {...params}
        />}
      />

      <FormGroup
        label='PT Licence Number'
        horizontal
        controlRender={(params) => <InputField
          title={'PT Licence Number'}
          name={'supervisorLicenseNumber'}
          onChange={handleChange}
          value={observationHoursDataEval.supervisorLicenseNumber ?? ''}
          {...params}
        />}
      />

      {stateValues.length > 0 ? <FormGroup
        label='State/Province'
        horizontal
        required
        controlRender={(params) => <DropdownField
          title="State/Province"
          name='supervisorState'
          selectedValue={observationHoursDataEval.supervisorState?.toString() ?? ''}
          onChange={handleStatesChange}
          options={
            [
              ...stateValues.filter(v => /international|other/i.test(v.valueId)),
              ...stateValues.filter(v => !/international|other/i.test(v.valueId))
                .sort((a, b) => a.valueString.localeCompare(b.valueString)),
            ]
              .map((s) => ({ value: s.id.toString(), title: s.valueString, ariaLabel: s.valueString }))}
          showDefault={true}
          {...params}
        />}
      /> : null}

    </div>
  ) : null;
}


export default PhysicalTherapistInfo;
